

export function parseJsonBill(jsonBill: any) {
  const sender = jsonBill['cfdi:Emisor'];
  const recipient = jsonBill['cfdi:Receptor'];
  const concepts = jsonBill['cfdi:Conceptos']['cfdi:Concepto'];
  const timbre = jsonBill['cfdi:Complemento']['tfd:TimbreFiscalDigital'];
  return {
    sender_name: sender.Nombre,
    sender_rfc: sender.Rfc,
    sender_tax_regime: sender.RegimenFiscal,
    receptor_name: recipient.Nombre,
    receptor_tax_regime: recipient.RegimenFiscalReceptor,
    receptor_rfc: recipient.Rfc,
    receptor_CFDI_usage: recipient.UsoCFDI,
    receptor_address: recipient.DomicilioFiscalReceptor,
    date: jsonBill.Fecha,
    signature: jsonBill.Sello,
    noCertificate: jsonBill.NoCertificado,
    certificate: jsonBill.Certificado,
    total: jsonBill.Total,
    subTotal: jsonBill.SubTotal,
    typeBill: jsonBill.TipoDeComprobante,
    paymentMethod: jsonBill.FormaPago,
    concepts: concepts,
    json_bill: JSON.stringify(jsonBill),
    status_bill: "Sin información",
    notes: '',
    invoiceType: '',
    uuid_bill: timbre.UUID
  }
}